module.exports = __webpack_public_path__ + "static/1-04d9d4225c07ecc0ab6d92a948c8937a.svg";